<template lang="html">
  <div :class="['page wrapper', {}]" id="checkout">
    <the-header></the-header>
    <div class="columns">
      <div class="column">
        <contact></contact>
      </div>
      <div class="column">
        <fees></fees>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Fees from '../components/home/Fees'
import Contact from '../components/checkout/Contact'
import TheHeader from '../components/common/TheHeader'
export default {
  name: 'checkout',
  data () {
    return {
    }
  },
  beforeMount () {
  },
  computed: {
    ...mapGetters([
    ])
  },
  mounted () {},
  methods: {
  },
  components: {
    Fees,
    Contact,
    TheHeader
  }
}
</script>
